export * from "./core/index.js";
export * from "./react/index.js";
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@apollo/client/index.js
// module id = 66
// module chunks = 0